var app = angular.module('leonardo');

var HasErrorDirective = function(ConfigThemeService) {
  return {
    restrict: 'A',
    scope: {
      error:'=?'
    },
    link: function (scope, element) {

      scope.$watch(
        function () {
          return scope.error;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function() {
        if (scope.error) {
          element.addClass('has-error');
          element.css('border-color', ConfigThemeService.getColor('errorColor'));
        }
        else {
          element.removeClass('has-error');
          element.css('border-color', ConfigThemeService.getColor('tertiaryColor'));
        }
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('hasError', ['ConfigThemeService', HasErrorDirective]);
